<template>
    <div class="searchItemTitle">{{ $t('Заказчик') }}</div>
    <v-col
        col="12"
        class="pa-0"
        v-if="allCustomers.length >= 5"
        v-show="showAll"
    >
        <v-text-field
            :label="$t('Найти')"
            variant="solo"
            v-model="searchQuery"
            clearable
            clear-icon="mdi-close"
            @click:clear="resetCustomerSearch"
            single-line
            hide-details
        />
    </v-col>
    <v-col
        col="12"
        class="pa-0"
        v-bind:class="customerListClasses"
    >
        <v-checkbox
            class="topCustomerCheckbox"
            v-for="(customer, index) in customers"
            :key="customer.value"
            v-model="searchParams.customers"
            v-show="index < 5 ? true : showAll"
            :label="customer.title"
            :value="customer.value"
            :true-icon="'mdi-check mdi-18px'"
            :false-icon="'voidCheckbox'"
            hide-details
        />
    </v-col>
    <a
        class="showMoreToggler"
        v-if="allCustomers.length > 5"
        v-show="showMoreToggler"
        @click="showMore"
    >{{ $t('Показать еще') }}</a>
    <a
        class="showMoreToggler"
        v-if="allCustomers.length > 5"
        v-show="showAll"
        @click="hideMore"
    >{{ $t('Свернуть') }}</a>
</template>

<script>
import api from "@/api";
import { toast } from '@/lib/toast';

export default {
    name: 'Customers',
    props: {
        searchParams: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            loading: false,
            topCustomers: [],
            allCustomers: [],
            searchQuery: null,
            showAll: false,
            showMoreToggler: true
        }
    },
    mounted() {
        this.loadCustomers();
    },
    computed: {
        customers() {
            let self = this;

            if (this.searchQuery != undefined && this.searchQuery != '') {
                return this.allCustomers.filter(function(org) {
                    return org.title.toLowerCase().includes(self.searchQuery.toLowerCase());
                });
            }
            return this.allCustomers;
        },
        customerListClasses: function() {
            return {
                customerListExtended: this.showAll && this.customers.length > 5
            }
        },
    },
    methods: {
        async loadCustomers() {
            if (this.loading) {
                return;
            }
            try {
                this.loading = true;
                let customers = await api.get('/procedures/getCustomerList');

                this.allCustomers = customers;
            } catch (e) {
                toast.error(e.message);
            }
            this.loading = false;
        },
        showMore() {
            this.showAll = true;
            this.showMoreToggler = false;
        },
        hideMore() {
            this.searchQuery = null;
            this.showAll = false;
            this.showMoreToggler = true;
        },
        resetCustomerSearch() {
            this.searchQuery = null;
        },
    },
}
</script>
<style scoped>
:deep(.v-input--density-default) {
    --v-input-control-height: auto;
}

:deep(.v-selection-control--density-default) {
    --v-selection-control-size: 30px;
}

:deep(.mdi-check.mdi-18px) {
    border-radius: 3px;
    border: 1px solid rgba(var(--black-color), 0.3);
}

:deep(.voidCheckbox) {
    border-radius: 3px;
    border: 1px solid rgba(var(--black-color), 0.3);
}

:deep(.topCustomerCheckbox .v-label) {
    color: rgb(var(--black-color));
    font-family: var(--primary-font-family-name);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 1;
    padding-left: 13px;
}

.showMoreToggler {
    font-family: var(--primary-font-family-name);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--intec-primary-color) !important;
    cursor: pointer;
}

.showMoreToggler:hover {
    text-decoration: underline;
}

:deep(.v-field--variant-solo, .v-field--variant-solo-filled) {
    border-radius: 6px;
    border: 1px solid rgba(var(--blue-blue-secondary-hover));
    box-shadow: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

:deep(.v-field--variant-solo:hover, .v-field--variant-solo-filled:hover) {
    border-color: rgba(var(--grey-1));
}

:deep(.v-label.v-field-label) {
    color: rgba(var(--black-color), 0.5);
    font-family: var(--primary-font-family-name);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

:deep(.v-input--density-default) {
    --v-input-padding-top: auto;
}

:deep(.v-field__input) {
    padding: 8px;
}

:deep(.v-input--selection-controls .v-input__control) {
    width: 100%;
}

:deep(.v-input__details) {
    min-height: auto;
}

.customerListExtended {
    min-height: 150px;
    overflow: hidden;
    overflow-y: auto;
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: rgba(var(--black-color), 0.3);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb {
    background: rgba(var(--black-color), 0.5);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgb(var(--black-color));
}

:deep(.v-field--variant-solo, .v-field--variant-solo-filled) {
    border-radius: 6px;
    border: 1px solid rgba(var(--blue-blue-secondary-hover));
    box-shadow: none;
    font-family: var(--primary-font-family-name) !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

:deep(.v-field--variant-solo:hover, .v-field--variant-solo-filled:hover) {
    border-color: rgba(var(--grey-1));
}
</style>